<template>
  <div class="snackbar">
    <slot></slot>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: "Snackbar",
    methods:{
      ...mapActions(['setError']),
    },
    created() {
      setTimeout(()=>{
        this.setError('');
      },2000)
    }
  }
</script>

<style scoped>
  .snackbar{
    height: 48px;
    background: #323232;
    line-height: 48px;
    color:#fff;
    padding-left: 20px;
    font-size: 14px;
    position: fixed;
    top:0;
    left:0;
    width:100%;
    z-index: 999;
  }
</style>